import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Sign in with your new password.");
      nav("/login");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 dark:bg-[#0B0F17] p-6">
      <div className="w-full max-w-sm">
        <h2 className="font-display text-2xl font-bold tracking-tight">Set a new password</h2>
        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">Minimum 8 characters.</p>
        {!token ? (
          <p className="mt-6 rounded-lg bg-red-50 dark:bg-red-500/10 p-3 text-sm text-red-600 dark:text-red-400" data-testid="reset-no-token">
            This reset link is missing its token. Request a new one.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="reset-form">
            <div>
              <Label htmlFor="rp-pass">New password</Label>
              <Input id="rp-pass" data-testid="reset-password" type="password" required minLength={8}
                value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-11" />
            </div>
            <div>
              <Label htmlFor="rp-confirm">Confirm password</Label>
              <Input id="rp-confirm" data-testid="reset-confirm" type="password" required minLength={8}
                value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5 h-11" />
            </div>
            <Button data-testid="reset-submit-btn" type="submit" disabled={busy}
              className="h-11 w-full bg-slate-900 hover:bg-slate-800 dark:bg-slate-100 dark:text-slate-900 font-semibold">
              {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Update password
            </Button>
          </form>
        )}
        <p className="mt-6 text-center text-sm">
          <Link to="/login" className="font-medium text-amber-600 hover:text-amber-700 dark:text-amber-400">← Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
